module.exports = __webpack_public_path__ + "img/category-fishing-game.98baa7c4.png";